<script lang="ts" setup></script>

<template>
  <v-btn
    class="rounded-circle pa-0 vertical-dots-button"
    elevation="0"
    height="30"
    min-height="30"
    min-width="30"
    variant="text"
    width="30"
  >
    <v-icon size="20">mdi-dots-vertical</v-icon>
  </v-btn>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color.scss";

.vertical-dots-button {
  &:hover {
    background-color: $indigo-lighten-5;

    .mdi-dots-vertical {
      color: $primary;
    }
  }
}
</style>
